const header = {
  "header.menu_01": "Home",
  "header.menu_02": "Discover Define®",
  "header.menu_03": "Virtual Mirror",
  "header.menu_04": "Shop Now",
  "header.list_menu_01": "The Catalogue",
  "header.list_menu_02": "Define® Classic",
  "header.list_menu_03": "Define® Fresh",
  "header.store_locator": "Store Locator",
  "header.store_01": "Lazada",
  "header.store_02": "Qoo10",
  "header.store_03": "Shopee",
}

export default header